import { render, staticRenderFns } from "./CRMSearchResults.vue?vue&type=template&id=ffca95b8&"
import script from "./CRMSearchResults.vue?vue&type=script&lang=js&"
export * from "./CRMSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports